import { Box, Button, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { useDispatch } from "react-redux";
import { generateCarrierStripeOnboardingSession } from "../../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";

const StripeOnboarding = ({ carrier, setLoading, setLoadingMessage }: any) => {
  const dispatch = useDispatch();

  const completeOnboarding = () => {
    setLoadingMessage("Preparing Stripe Onboarding...");
    setLoading(true);
    dispatch<any>(generateCarrierStripeOnboardingSession(carrier.id))
      .then(unwrapResult)
      .then((res: any) => {
        window.location.href = res.url;
        setTimeout(() => {
          setLoading(false);
          setLoadingMessage("");
        }, 2000);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingMessage("");
        setLoading(false);
      });
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
        padding: 3,
        width: "100%",
        maxWidth: 1200,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          width: "100%",
          maxWidth: 900,
          padding: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "#F5F5F5",
          border: "1px solid #DCDCDC",
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          color="success"
          sx={{ mb: 2 }}
        >
          PLEASE COMPLETE YOUR STRIPE ONBOARDING
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: "#000000" }}>
          Please complete your Stripe onboarding to continue receiving payments.
          If you don't finish the process, you won't be able to receive payments
          from your customers.
        </Typography>

        <Button
          variant="contained"
          color="success"
          sx={{ fontSize: 16, padding: "10px 20px" }}
          onClick={() => {
            completeOnboarding();
          }}
          startIcon={<ErrorIcon />}
        >
          Complete Onboarding
        </Button>

        <Typography variant="body2" sx={{ mt: 2 }} color="textSecondary">
          Click the button to complete your stripe onboarding.
        </Typography>
      </Box>
    </Box>
  );
};
export default StripeOnboarding;
